@switch (mode) {
    @case ('single') {
        <div class="single-entry flex flex-col">
            <div class="customer-header fg-petroleum">
                <div class="customer-line body-copy gap-3px">
                    <div class="body-header" translate="userProfile.customerRelations.customerNumber"></div>
                    <div>{{ installation.customerNumber }}</div>

                    @if (showSingleAddress()) {
                        <div class="prefix">
                            <span>{{ formatAddress(installation.installations[0].address) }}</span>
                        </div>
                    }
                </div>
            </div>
            <span class="body-header" translate="userProfile.customerRelations.installationAddress"></span>
            @for (inst of installation.installations; track inst) {
                <span class="flex flex-col single-installation-cell">
                    <app-installation-cell [installation]="inst" [showMeterInfo]="false"></app-installation-cell>
                </span>
            }
        </div>
    }
    @case ('radio') {
        <div class="radio-entry-container">
            <mat-radio-button
                class="flex body-copy radio-entry-wrapper installation-radio brand-radio"
                [value]="installation"
                (change)="onRadioChange()"
                [checked]="isSelected"
            >
                <div class="flex flex-col sm:flex-row flex-grow">
                    <div class="flex flex-col w-full">
                        <div class="customer-header flex flex-wrap fg-petroleum">
                            <div class="customer-line body-copy gap-3px">
                                <div class="body-header" translate="userProfile.customerRelations.customerNumber"></div>
                                <div>{{ installation.customerNumber }}</div>

                                @if (installation.installations.length === 1 && installation.installations[0].address) {
                                    <div class="prefix">
                                        <span>{{ formatAddress(installation.installations[0].address) }}</span>
                                    </div>
                                }
                            </div>
                        </div>
                        <app-installation-selector
                            class="radio-installation-selector"
                            [installation]="installation"
                            [isBusiness]="isBusiness"
                            [isParentSelected]="isSelected"
                            (installationSelected)="onInstallationSelected($event)"
                        ></app-installation-selector>
                    </div>
                </div>
            </mat-radio-button>
        </div>
    }
}
